let bsParams = {
  /* 音像制品 基本情况表 */

  xkzNum: "", // 出版许可证号
  orgName: "", // 单位名称
  orgAddr: "", // 单位地址
  cbzMa: "", // 出版者码
  fddbr: "", // 法定代表人

  areaDate: "",

  yxStartDate: "", // 有效开始日期
  yxEndDate: "", // 有效截止日期
  businessScope: "", // 经营范围
  otherScope: "", // 其他主要业务
  approvalTime: "", // （音像/电子）制品出版资质获批时间
  otherSituation: "", // 需要说明的其他情况
  xkzFileId: "", // 出版许可证ID

  hostId: "", // 主办单位ID
  hostName: "", // 主办单位名称
  hostAddr: "", // 主办单位地址
  hostPostalcode: "", // 主办单位邮编
  hostLinkman: "", // 主办单位联系人
  hostTel: "", // 主办单位联系电话
  hostPhone: "", // 主办单位联系人手机

  chargeId: "", // 主管单位ID
  chargeName: "", // 主管单位名称
  chargeAddr: "", // 主管单位地址
  chargePostalcode: "", // 主管单位邮编
  chargeLinkman: "", // 主管单位联系人
  chargeTel: "", // 主管单位联系电话
  chargePhone: "", // 主管单位联系人手机

  publishMaterialId: "", // publishMaterialId
  publishId: "", // 出版单位ID
  id: "", // id
  updatedAt: "", //申报时间
};

let idCard = (rule, val, callback) => {
  let pattern =
    /^([1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx])|([1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2})$/;
  if (val == "") {
    callback(new Error("请输入身份证号"));
  } else if (!pattern.test(val)) {
    callback(new Error("身份证号错误"));
  } else {
    callback();
  }
};

let homePhone = (rule, val, callback) => {
  //固话验证
  var pattern = /(^(0\d{2,3})?-?\d{7,8}$)$/;
  if (val == "") {
    callback(new Error("请输入电话"));
  } else if (!pattern.test(val)) {
    callback(new Error("电话格式错误！"));
  } else {
    callback();
  }
};

let zipCode = (rule, val, callback) => {
  // 邮编验证
  var pattern = /(^[0-9]{6})$/;
  if (val == "") {
    callback(new Error("请输入单位邮编"));
  } else if (!pattern.test(val)) {
    callback(new Error("邮编格式错误！"));
  } else {
    callback();
  }
};

let mobelPhone = (rule, val, callback) => {
  // 手机验证
  var pattern = /^1[0-9]{10}$/;
  if (val == "") {
    callback(new Error("请输入手机号"));
  } else if (!pattern.test(val)) {
    callback(new Error("手机号格式错误！"));
  } else {
    callback();
  }
};

let nameMatch1 = (rule, val, callback) => {
  var weqName = bsParams.orgName.replace(/\s*/gi, "");
  var inName = val.replace(/\s*/gi, "");
  if (inName.length == 0) {
    callback(new Error("不能为空！"));
  } else {
    // if (inName == weqName) {
    //   callback(new Error('主办单位名称不能与单位名称相同！'));
    // } else
    if (inName.length > 127) {
      callback(new Error("内容过长！"));
    } else {
      callback();
    }
  }
};

let nameMatch2 = (rule, val, callback) => {
  var weqName = bsParams.orgName.replace(/\s*/gi, "");
  var inName = val.replace(/\s*/gi, "");
  if (inName.length == 0) {
    callback(new Error("不能为空！"));
  } else {
    if (inName == weqName) {
      callback(new Error("主管单位名称不能与单位名称相同！"));
    } else if (inName.length > 127) {
      callback(new Error("内容过长！"));
    } else {
      callback();
    }
  }
  if (inName.length > 0) {
  }
};

let nameMatch3 = (rule, val, callback) => {
  var weqName1 = bsParams.hostName.replace(/\s*/gi, "");
  var weqName2 = bsParams.chargeName.replace(/\s*/gi, "");
  var inName = val.replace(/\s*/gi, "");
  if (inName.length == 0) {
    callback(new Error("不能为空！"));
  } else {
    if (inName == weqName1) {
      callback(new Error("单位名称不能与主办单位名称相同！"));
    } else if (inName == weqName2) {
      callback(new Error("单位名称不能与主管单位名称相同！"));
    } else if (inName.length > 127) {
      callback(new Error("内容过长！"));
    } else {
      callback();
    }
  }
};

let paramsRule = {
  xkzNum: [
    {
      required: true,
      message: "不能为空！",
      trigger: "blur",
    },
    {
      max: 127,
      message: "填写内容过长！",
      trigger: "blur",
    },
  ], // 出版许可证号
  orgName: [
    {
      validator: nameMatch3,
      trigger: "blur",
    },
  ], // 单位名称
  orgAddr: [
    {
      required: true,
      message: "不能为空！",
      trigger: "blur",
    },
    {
      max: 127,
      message: "填写内容过长！",
      trigger: "blur",
    },
  ], // 单位地址
  cbzMa: [
    {
      required: true,
      message: "不能为空！",
      trigger: "blur",
    },
    {
      max: 127,
      message: "填写内容过长！",
      trigger: "blur",
    },
  ], // 出版者码
  fddbr: [
    {
      required: true,
      message: "不能为空！",
      trigger: "blur",
    },
    {
      max: 127,
      message: "填写内容过长！",
      trigger: "blur",
    },
  ], // 法定代表人

  areaDate: [
    {
      required: true,
      message: "请选择",
      trigger: "change",
    },
  ],

  yxStartDate: [
    {
      required: true,
      message: "请选择",
      trigger: "change",
    },
  ], // 有效开始日期
  yxEndDate: [
    {
      required: true,
      message: "请选择",
      trigger: "change",
    },
  ], // 有效截止日期

  businessScope: [
    {
      required: true,
      message: "不能为空！",
      trigger: "blur",
    },
    {
      max: 600,
      message: "填写内容过长！",
      trigger: "blur",
    },
  ], // 经营范围
  otherScope: [
    {
      required: true,
      message: "不能为空！",
      trigger: "blur",
    },
    {
      max: 127,
      message: "填写内容过长！",
      trigger: "blur",
    },
  ], // 其他主要业务
  approvalTime: [
    {
      required: true,
      message: "请选择",
      trigger: "change",
    },
  ], // （音像/电子）制品出版资质获批时间
  otherSituation: [
    {
      required: true,
      message: "请选择",
      trigger: "change",
    },
  ], // 需要说明的其他情况

  // xkzFileId:[
  // 	   { required:true, message:'请上传', trigger:'change' },
  // ],

  xkzFileId1: [
    {
      required: true,
      message: "请上传",
      trigger: "change",
    },
  ],
  xkzFileId2: [
    {
      required: true,
      message: "请上传",
      trigger: "change",
    },
  ],
  xkzFileId3: [
    {
      required: true,
      message: "请上传",
      trigger: "change",
    },
  ],
  xkzFileId4: [
    {
      required: true,
      message: "请上传",
      trigger: "change",
    },
  ],
  xkzFileId5: [
    {
      required: true,
      message: "请上传",
      trigger: "change",
    },
  ],

  hostName: [
    {
      validator: nameMatch1,
      trigger: "blur",
    },
  ], // 主办单位名称

  hostCategory: [
    {
      required: true,
      message: "不能为空！",
      trigger: "blur",
    },
  ], // 主办单位名称

  hostAddr: [
    {
      required: true,
      message: "不能为空！",
      trigger: "blur",
    },
    {
      max: 127,
      message: "填写内容过长！",
      trigger: "blur",
    },
  ], // 主办单位地址
  hostPostalcode: [
    {
      validator: zipCode,
      trigger: "blur",
    },
  ], // 主办单位邮编
  hostLinkman: [
    {
      required: true,
      message: "不能为空！",
      trigger: "blur",
    },
    {
      max: 127,
      message: "填写内容过长！",
      trigger: "blur",
    },
  ], // 主办单位联系人
  hostTel: [
    {
      validator: homePhone,
      trigger: "blur",
    },
  ], // 主办单位联系电话
  hostPhone: [
    {
      validator: mobelPhone,
      trigger: "blur",
    },
  ], // 主办单位联系人手机

  chargeName: [
    {
      validator: nameMatch2,
      trigger: "blur",
    },
  ], // 主管单位名称

  chargeCategory: [
    {
      required: true,
      message: "不能为空！",
      trigger: "blur",
    },
  ], // 主办单位名称
  chargeAddr: [
    {
      required: true,
      message: "不能为空！",
      trigger: "blur",
    },
    {
      max: 127,
      message: "填写内容过长！",
      trigger: "blur",
    },
  ], // 主管单位地址
  chargePostalcode: [
    {
      validator: zipCode,
      trigger: "blur",
    },
  ], // 主管单位邮编
  chargeLinkman: [
    {
      required: true,
      message: "不能为空！",
      trigger: "blur",
    },
    {
      max: 127,
      message: "填写内容过长！",
      trigger: "blur",
    },
  ], // 主管单位联系人
  chargeTel: [
    {
      validator: homePhone,
      trigger: "blur",
    },
  ], // 主管单位联系电话
  chargePhone: [
    {
      validator: mobelPhone,
      trigger: "blur",
    },
  ], // 主管单位联系人手机
};

export { bsParams, paramsRule };



// WEBPACK FOOTER //
// ./src/components/LongParams/paramsEt2.js